import { Box } from '@mui/material';
import { CVBuilderFormKeys, ExperienceEntry } from 'utils/cv-form-db';
import { EditModeNavigationButtons } from '../../components/EditModeNavigationButtons';
import { PreviousStepNavigationButton } from '../../components/PreviousStepNavigationButton';
import { StepNavigationButton } from '../../components/StepNavigationButton';
import { RootBox } from '../../components/styledComponents';
import { useCVStepActions } from '../../hooks';
import { useEditModeNavigation } from '../../hooks/useEditModeNavigation';
import { DeleteProfessionalExperienceModal } from './DeleteProfessionalExperienceModal';
import { ProfessionalExperienceContent } from './ProfessionalExperienceContent';
import { useProfessionalExperienceNavigation } from './useProfessionalExperienceNavigation';

export const ProfessionalExperienceStep = () => {
  const { isEditMode } = useEditModeNavigation();

  const {
    isFormOpen,
    isEditing,
    editingItem,
    deleteModalState,
    handleAdd,
    handleEdit,
    handleDeleteClick,
    handleConfirmDelete,
    handleCancelDelete,
    handleEditClick,
    handleAddClick,
    handleCancelForm
  } = useCVStepActions<ExperienceEntry>({
    fieldName: CVBuilderFormKeys.PROFESSIONAL_EXPERIENCE,
    sortFunction: (a, b) => {
      const dateA = new Date(a.startDate || 0);
      const dateB = new Date(b.startDate || 0);
      return dateB.getTime() - dateA.getTime();
    },
    disableAutoSave: isEditMode
  });

  const { handleBeforeNavigate } = useProfessionalExperienceNavigation();

  const handleEditByIndex = (index: number) => {
    handleEditClick(index);
  };

  const handleDeleteByIndex = (index: number) => {
    handleDeleteClick(index);
  };

  if (isEditMode) {
    return (
      <RootBox
        sx={{
          height: '100%',
          display: 'flex',
          flexDirection: 'column'
        }}
      >
        <ProfessionalExperienceContent
          isFormOpen={isFormOpen}
          isEditing={isEditing}
          editingItem={editingItem || null}
          onAdd={handleAdd}
          onEdit={handleEdit}
          onCancel={handleCancelForm}
          onAddClick={handleAddClick}
          onEditClick={handleEditByIndex}
          onDeleteClick={handleDeleteByIndex}
        />
        <Box sx={{ flex: 1 }} />
        {!isFormOpen && <EditModeNavigationButtons />}
        <DeleteProfessionalExperienceModal
          isOpen={deleteModalState.isOpen}
          onClose={handleCancelDelete}
          onConfirm={handleConfirmDelete}
        />
      </RootBox>
    );
  }

  return (
    <RootBox
      sx={{
        height: '100%',
        display: 'flex',
        flexDirection: 'column'
      }}
    >
      <ProfessionalExperienceContent
        isFormOpen={isFormOpen}
        isEditing={isEditing}
        editingItem={editingItem || null}
        onAdd={handleAdd}
        onEdit={handleEdit}
        onCancel={handleCancelForm}
        onAddClick={handleAddClick}
        onEditClick={handleEditByIndex}
        onDeleteClick={handleDeleteByIndex}
      />
      <Box sx={{ flex: 1 }} />
      {!isFormOpen && (
        <>
          <StepNavigationButton
            step="PROFESSIONAL_EXPERIENCE"
            onBeforeNavigate={handleBeforeNavigate}
          />
          <PreviousStepNavigationButton step="PROFESSIONAL_EXPERIENCE" />
        </>
      )}
      <DeleteProfessionalExperienceModal
        isOpen={deleteModalState.isOpen}
        onClose={handleCancelDelete}
        onConfirm={handleConfirmDelete}
      />
    </RootBox>
  );
};
